import { Search } from 'lucide-react';
import { Button } from '../ui/button';
import useSearchStore from '../../store/useSearchStore';

export function SearchButton() {
  const setOpen = useSearchStore((state) => state.setOpen);
  const isMac = navigator.platform.toUpperCase().indexOf('MAC') >= 0;

  return (
    <Button
      variant="outline"
      size="sm"
      onClick={() => setOpen(true)}
      className="gap-2 text-muted-foreground"
      data-testid="search-button"
    >
      <Search className="h-4 w-4" />
      <span className="hidden sm:inline-flex items-center gap-1">
        Search
        <kbd className="pointer-events-none h-5 select-none items-center gap-1 border bg-muted px-1.5 font-mono text-[10px] font-medium opacity-100 hidden sm:inline-flex">
          {isMac ? '⌘' : 'Ctrl'}K
        </kbd>
      </span>
    </Button>
  );
}
